import { z } from 'zod';
import { radius } from '../../elements/radius';
import { spacing } from '../../elements/spacing';

/** Geometry only: loading semantics and announcements belong to the host. */
export const skeletonBlockPropsSchema = z
  .object({
    width: z.union([z.number().positive(), z.literal('fill')]).default('fill'),
    height: z.number().positive().default(spacing.m),
    radius: z
      .enum([
        's',
        'sm',
        'm',
        'lg',
        'xl',
        'xxl',
        'xxxl',
        'rounded',
      ] satisfies (keyof typeof radius)[])
      .default('m'),
    active: z.boolean().default(true),
    testID: z.string().optional(),
  })
  .strict();

export type SkeletonBlockProps = z.infer<typeof skeletonBlockPropsSchema>;
